// X (Twitter) Ads pixel — the Universal Website Tag (uwt.js / `twq`).
//
// Purpose: let X attribute conversions and build a retargeting audience, on top
// of our own first-touch UTM capture in ./attribution.js. The two are
// complementary — attribution.js tells OUR dashboard which channel drove a
// signup; this tells X's optimizer so it can find more people like the ones who
// convert.
//
// INERT BY DEFAULT. Configured via build-time env vars:
//   REACT_APP_X_PIXEL_ID         — the pixel/base tag id from X Ads Manager
//   REACT_APP_X_SIGNUP_EVENT_ID  — the conversion-event id X generates when you
//                                  create the "signup" event (looks like tw-xxxx-xxxx)
// With no PIXEL_ID set — locally, or before you paste the value from X — every
// function here is a no-op: no script loads and nothing is sent to X.
//
// ⚠️ react-scripts bakes REACT_APP_* at BUILD time, so these must be set on the
// frontend's Railway *build* environment (not just runtime) to take effect.
//
// ⚠️ The production CSP in backend/main.py must allow static.ads-twitter.com
// (script-src) and analytics.twitter.com (connect-src) — already added there.

const PIXEL_ID = process.env.REACT_APP_X_PIXEL_ID || '';
const SIGNUP_EVENT_ID = process.env.REACT_APP_X_SIGNUP_EVENT_ID || '';
// Mid-funnel event id (create a second "graded a ticker" conversion in X Ads,
// paste its tw-xxxx-xxxx id here at build time). Optional — inert if unset.
const GRADE_EVENT_ID = process.env.REACT_APP_X_GRADE_EVENT_ID || '';

// Load the base tag once and fire the initial PageView. Safe to call on every
// app boot; the window.twq guard keeps injection to a single time.
export function initXPixel() {
  if (!PIXEL_ID) return; // not configured — stay completely inert
  if (window.twq) return; // already initialised
  try {
    /* eslint-disable */
    !function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
    },s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='https://static.ads-twitter.com/uwt.js',
    a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script');
    /* eslint-enable */
    window.twq('config', PIXEL_ID);
  } catch {
    // never let an analytics tag break the app
  }
}

// Fire the mid-funnel "graded a ticker" conversion event. A cold ad visitor who
// grades a ticker on the free hero/screener is a high-intent, sign-up-correlated
// action that happens FAR more often than signups — so a Conversions campaign
// optimized toward this event has enough volume to actually learn (signups alone
// are too sparse to optimize on). No-op unless BOTH the pixel and this event id
// are configured, so it's harmless until you set it up in X.
export function trackGrade() {
  if (!PIXEL_ID || !GRADE_EVENT_ID) return;
  try {
    if (!window.twq) initXPixel();
    window.twq('event', GRADE_EVENT_ID, {});
  } catch {
    // best-effort; a missed analytics ping must never block the UI
  }
}

// Fire the signup conversion event. Call right after a successful register,
// before the auto-login page reload. No-op unless BOTH the pixel and the event
// id are configured, so it's harmless until you've set them up in X.
export function trackSignup() {
  if (!PIXEL_ID || !SIGNUP_EVENT_ID) return;
  try {
    if (!window.twq) initXPixel();
    window.twq('event', SIGNUP_EVENT_ID, {});
  } catch {
    // best-effort; a missed conversion ping must never block signup
  }
}
